import React, { createContext, useContext, useMemo, useState } from 'react';
import { SaveStatus } from '../types';

interface SaveStatusContextValue {
  /** null when no diagram is open (Home, Settings) or in the demo. */
  saveStatus: SaveStatus | null;
  setSaveStatus: (status: SaveStatus | null) => void;
}

const SaveStatusContext = createContext<SaveStatusContextValue | null>(null);

/**
 * Lifts the editor's save status out of the editor so the tab strip — which
 * renders above the route outlet — can show it.
 */
export function SaveStatusProvider({ children }: { children: React.ReactNode }) {
  const [saveStatus, setSaveStatus] = useState<SaveStatus | null>(null);
  const value = useMemo(() => ({ saveStatus, setSaveStatus }), [saveStatus]);
  return <SaveStatusContext.Provider value={value}>{children}</SaveStatusContext.Provider>;
}

export function useSaveStatus(): SaveStatusContextValue {
  const ctx = useContext(SaveStatusContext);
  if (!ctx) throw new Error('useSaveStatus must be used within a SaveStatusProvider');
  return ctx;
}
